import { Stack } from '@mui/material'
import { FC } from 'react'
import { LocationChangeLogs } from './LocationChangeLog'
import { PermittingChangelog } from './PermittingChangeLog'
import { useParams } from 'react-router-dom'
import { useLocation as useLocationData } from '../../../../api/apiQueries'

export const ChangeLogTab: FC = () => {
  const { sid: locationId } = useParams()
  const locationQuery = useLocationData(locationId)

  const locationData = locationQuery.data

  return (
    <Stack sx={{ gap: '1.5rem' }}>
      {locationData && (
        <>
          <LocationChangeLogs location={locationData} />
          <PermittingChangelog location={locationData} />
        </>
      )}
    </Stack>
  )
}
